import type { CSSProperties, HTMLAttributes } from 'react'

import styles from './Skeleton.module.css'

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  width?: CSSProperties['width']
  height?: CSSProperties['height']
  radius?: CSSProperties['borderRadius']
  lineWidth?: '40' | '60' | '80'
}

export function Skeleton({ width, height, radius, lineWidth, className = '', style, ...props }: SkeletonProps) {
  const lineClass = lineWidth ? `${styles.line} ${styles[`w${lineWidth}`]}` : ''
  return (
    <div
      className={`${styles.skeleton} ${lineClass} ${className}`}
      style={{ width, height, borderRadius: radius, ...style }}
      {...props}
    />
  )
}
